export default "__VITE_ASSET__b2297f88__"